import { render, staticRenderFns } from "./BusinessChart.vue?vue&type=template&id=4e4658a8&scoped=true&"
import script from "./BusinessChart.vue?vue&type=script&lang=js&"
export * from "./BusinessChart.vue?vue&type=script&lang=js&"
import style0 from "./BusinessChart.vue?vue&type=style&index=0&id=4e4658a8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e4658a8",
  null
  
)

export default component.exports